/**
 * Bind Capacitor camera / GPS controls after form HTML is injected.
 * Keeps form.js renderers declarative; native side-effects live here.
 */
import { capturePhoto } from './native/camera.js';
import { formatCoordinates, getCurrentCoordinates } from './native/geolocation.js';
import { toast } from './ui.js';

export function bindNativeFormControls(root = document) {
  root.querySelectorAll('[data-capture-photo]').forEach((button) => {
    button.addEventListener('click', async () => {
      const fieldId = button.getAttribute('data-capture-photo');
      const wrap = root.querySelector(`[data-field="${fieldId}"]`);
      const hidden = wrap?.querySelector(`input[name="${fieldId}"]`);
      const preview = wrap?.querySelector('[data-photo-preview]');
      if (!hidden) return;

      button.disabled = true;
      const old = button.textContent;
      button.textContent = 'Đang mở camera...';
      try {
        const photo = await capturePhoto();
        hidden.value = photo.dataUrl;
        if (preview) {
          preview.hidden = false;
          preview.src = photo.dataUrl;
        }
        toast('Đã chụp ảnh hiện trường.', 'success');
      } catch (error) {
        toast(error.message || 'Không chụp được ảnh.', 'warn');
      } finally {
        button.disabled = false;
        button.textContent = old;
      }
    });
  });

  root.querySelectorAll('[data-capture-gps]').forEach((button) => {
    button.addEventListener('click', async () => {
      const fieldId = button.getAttribute('data-capture-gps');
      const wrap = root.querySelector(`[data-field="${fieldId}"]`);
      const hidden = wrap?.querySelector(`input[name="${fieldId}"]`);
      const display = wrap?.querySelector('[data-gps-display]');
      if (!hidden) return;

      button.disabled = true;
      const old = button.textContent;
      button.textContent = 'Đang lấy GPS...';
      try {
        const coords = await getCurrentCoordinates();
        hidden.value = JSON.stringify(coords);
        if (display) {
          display.textContent = formatCoordinates(coords);
        }
        toast('Đã lấy tọa độ hiện trường.', 'success');
      } catch (error) {
        toast(error.message || 'Không lấy được GPS.', 'warn');
      } finally {
        button.disabled = false;
        button.textContent = old;
      }
    });
  });
}
